// extracted by mini-css-extract-plugin
export default {"removeBtn":"AddSignatureModal_removeBtn__CAygX","addBtn":"AddSignatureModal_addBtn__ujkRq","spliter":"AddSignatureModal_spliter__wEjNj"};